import { useCallback } from 'react';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { requestViewerNewUserEmailVerification } from './api/graphql/requestViewerNewUserEmailVerification';
import { verifyNewUserEmail } from './api/graphql/verifyNewUserEmail';

/**
 * Which flow asked for the verification email; it decides which mutation sends (and resends) it.
 * - `viewer`: the session user (the vault gate), so no user id is sent.
 * - `guest`: an existing account found by email during checkout.
 */
export type EmailVerificationFlow = { kind: 'viewer' } | { kind: 'guest'; userId: string };

export function useSendVerificationEmail(): (path: string, flow: EmailVerificationFlow) => Promise<boolean> {
	const utilityContext = useUtilityContext();

	return useCallback(
		async (path, flow) => {
			if (flow.kind === 'viewer') return requestViewerNewUserEmailVerification(path, utilityContext);
			return verifyNewUserEmail(path, utilityContext, flow.userId);
		},
		[utilityContext],
	);
}
